<!--
 * @Author: xiaohe
 * @LastEditors: xiaohe
-->
<template>
  <div class="payInfo">
    <PlateTitle title="请及时完成支付">
      <template v-slot:subtitle>
        <span class="subtitle">业务流水号：{{ orderNo }}</span>
      </template>
    </PlateTitle>
    <div class="main">
      <a-form :label-col="{ span: 10 }" :wrapper-col="{ span: 12}">
        <a-form-item label="投标企业名称" has-feedback>
          <span>{{ infoJson.enterpriseName }}</span>
        </a-form-item>
        <a-form-item label="投标企业社会信用代码" has-feedback>
          <span>{{ infoJson.orderCode }}</span>
        </a-form-item>
        <a-form-item label="担保保额（元）" has-feedback>
          <span>{{ infoJson.sumAmount }}</span>
        </a-form-item>
        <a-form-item label="担保保费（元）" has-feedback>
          <span>{{ infoJson.sumPremium }}</span>
        </a-form-item>
      </a-form>
    </div>
    <!-- sTitle="支付时必须使用企业基本户支付，不然会引起废标" -->
    <PlateTitle title="请点击选择支付方式"  />
    
    <!-- <div class="pay_info">
      <div class="pay" :class="{'active': payVal === 1}" @click="choose(1)" >
        <img class="choose" v-if="payVal === 1" src="../../assets/image/icon-cg.png" alt="" />
        <p class="pay_c">微信支付</p>
      </div>
      <div class="pay" :class="{'active': payVal === 2}" @click="choose(2)">
        <img class="choose" v-if="payVal === 2" src="../../assets/image/icon-cg.png" alt="" />
        <p class="pay_c">支付宝支付</p>
      </div>
      <div class="pay" :class="{'active': payVal === 7}" @click="choose(7)">
        <img class="choose" v-if="payVal === 7" src="../../assets/image/icon-cg.png" alt="" />
        <p class="pay_p">线下支付<br/>(人工审批)</p>
      </div>
    </div> -->

    <div class="pay_info">
      <div @click="handeClick(infoJson.zfbPayBase64, 1)" class="info_box">
        <div class="head_s">支付宝支付</div>
        <div class="logo">
          <img v-if="!zfbImg" src="../../assets/image/pic_zfbzf.png" alt="" />
          <img v-else :src="zfbImg" alt="" />
        </div>
      </div>
      <div @click="handeClick(infoJson.wechatPayBase64, 2)" class="info_box">
        <div class="head_s">微信支付</div>
        <div class="logo">
          <img v-if="!wxImg" src="../../assets/image/pic_wxzf.png" alt="" />
          <img v-else :src="wxImg" alt="" />
        </div>
      </div>
      <div @click="submitXX()" class="info_box">
        <div class="head_xx">线下支付<br/>(人工审批)</div>
      </div>
    </div>
    <!-- <div class="submitBtn" @click="submit">确认提交</div> -->
  </div>
</template>
<script>
import PlateTitle from "@/components/PlateTitle";
import { getBase64 ,getPaymentInfo} from "./api.js";
export default {
  components: {
    PlateTitle,
  },
  data() {
    return {
      infoJson: {},
      orderNo: "",
      platformType: "",
      payVal: 7,
      url1: '',
      url2: '',
      url3: '',
      wxImg: "",
      zfbImg: "",
    };
  },
  mounted() {
    this.init();
    this.orderNo = this.getQueryString("orderNo");
    this.platformType = this.getQueryString("platformType");
  },
  methods: {
    getQueryString(name) {
      const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      const r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    async init() {
      this.orderNo = this.getQueryString("orderNo");
      this.platformType = this.getQueryString("platformType");
      const { data: data } = await getPaymentInfo({
        orderNo: this.orderNo,
        platformType: 6,
      });
      this.infoJson = data.data;
      this.infoJson.actualPayments.map((item) => {
        if(item.payType === "4") {
          this.url2 = item.payUrl
        }else if(item.payType === "7"){
          this.url3 = item.payUrl
        }else {
          this.url1 = item.payUrl
        }
      })
      if(this.infoJson.offlineVouchStatus === "1") {
        this.$router.push({ path: "/payInfo", query: { orderNo: this.orderNo } });
      }
    },
    choose(v) {
      this.payVal = v
    },
    submit() {
      if(this.payVal === 1) {
        if(this.platformType === 5){
          this.$router.push({ path: "/payWait", query: { orderNo: this.orderNo } });
        } else {
          window.open(this.url1)
        }
      }else if(this.payVal === 7) {
        window.open(this.url3)
      } else {
          window.open(this.url2)
        //this.$router.push({ path: "/payInfo", query: { orderNo: this.orderNo } });
      }
    },
    handeClick(url, val) {
      getBase64(url).then(({ data: data }) => {
        if (val == 1) {
          this.zfbImg = data.data.qrcode;
        } else {
          this.wxImg = data.data.qrcode;
        }
      });
    },
    submitXX(){
      window.open(this.infoJson.offlineVouchUrl)

    }
  },
};
</script>

<style lang="less" scoped>
.payInfo {
  width: 1200px;
  min-height: 820px;
  background: #ffffff;
  box-shadow: 0px 4px 4px 0px rgba(0, 124, 226, 0.03);
  border-radius: 2px 2px 2px 2px;
  margin: auto;
  margin-top: 24px;
  padding: 40px 30px 0 30px;
  .subtitle {
    font-size: 14px;
    line-height: 28px;
  }
  ::v-deep .ant-form-item-label {
    width: 192px;
    padding-left: 24px;
    font-size: 16px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-right: 10px;
  }
  ::v-deep .ant-form-item-children {
    font-size: 16px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #666666;
  }
  /deep/ .ant-form-item {
    margin-bottom: 10px !important;
  }
  .main {
    margin-top: 20px;
    margin-bottom: 30px;
  }
  .pay_info {
    display: flex;
    margin-left: 80px;
    margin-bottom:80px;
    .info_box {
      width: 380px;
      height: 400px;
      background: #ffffff;
      box-shadow: 5px 15px 30px 5px rgba(75, 111, 158, 0.15);
      border-radius: 5px 5px 5px 5px;
      margin-right: 20px;
      cursor: pointer;
      .head_s {
        padding-top: 40px;
        text-align: center;
        font-size: 18px;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #333333;
      }
      .head_xx{
        padding-top: 140px;
        text-align: center;
        font-size: 18px;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #333333;
      }
      .logo {
        margin: auto;
        width: 150px;
        height: 150px;
        margin-top: 33px;
        img {
          width: 150px;
          height: 150px;
        }
      }
    }
    .pay {
      display: flex;
      width: 160px;
      height: 60px;
      border: 1px solid #ccc;
      border-radius: 8px;
      margin-right: 20px;
      cursor: pointer;
      position: relative;
      .payImg {
        width: 120px;
        height: 40px;
        position: relative;
        top: 10px;
        left: 15px;
      }
      .choose {
        width: 16px;
        height: 16px;
        position: absolute;
        top: 3px;
        right: 3px;
        z-index: 2;
      }
    }
    .active {
      border-color: #0E52D4;
    }
  }
  .submitBtn {
    width: 160px;
    height: 35px;
    text-align: center;
    line-height: 35px;
    background: #0E52D4;
    color: #ffffff;
    border-radius: 5px;
    margin: 100px auto 0;
    cursor: pointer;
  }
}
.pay_p{
  width: 100%;
  text-align: center!important;
  font-size: 16px;
  font-weight: bold;
  margin-top: 4px;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  color: #333;
}
.pay_c{
  width: 100%;
  text-align: center!important;
  font-size: 16px;
  font-weight: bold;
  margin-top: 16px;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  color: #333;
}
</style>
